import {
  UserDetailsCard,
  UserDetailsRow,
  UserDetailsRowTitle,
  UserDetailsRowValue,
} from '@/bundle/_Opco/shared/styles';
import UserIcon from '@/bundle/_Opco/_OpcoUsersPage/OpcoUserDetailsPage/images/UserIcon.svg?react';
import { Box } from '@/components/Box/Box';
import { UserDetailsEditableRow } from '@/bundle/_Opco/ui/OrganizationDetails/Details/ui/OrganizationUserAccountDetails/styles';
import EditIcon from '@/images/EditIcon.svg?react';
import { UserDetailsHeader } from './UserDetailsHeader/UserDetailsHeader';
import { amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { AMPLITUDE_EVENTS } from '@/services/amplitudeService/amplitudeEvents';
import { IconButton } from '@/components/IconButton/IconButton';

export type PersonalDetailsType = {
  first_name?: string;
  middle_name?: string;
  last_name?: string;
};

type UserPersonalDetailsType = {
  onEditOpen: () => void;
  personalDetails: PersonalDetailsType;
  isEdit: boolean;
};

export const UserPersonalDetails = ({ onEditOpen, personalDetails, isEdit }: UserPersonalDetailsType) => {
  const openEdit = () => {
    amplitudeService.logEvent(AMPLITUDE_EVENTS.ProfileEditPersonalInfoRedirect);

    onEditOpen();
  };

  const { first_name, middle_name, last_name } = personalDetails || {};

  return (
    <Box flexDirection='column' width='100%'>
      <UserDetailsHeader title='Personal Information' icon={<UserIcon />}></UserDetailsHeader>
      <UserDetailsCard>
        <UserDetailsRow>
          <Box flexDirection='row' justifyContent='space-between'>
            <UserDetailsEditableRow>
              <UserDetailsRowTitle>First Name</UserDetailsRowTitle>
              <UserDetailsRowValue>{first_name || '-'}</UserDetailsRowValue>
            </UserDetailsEditableRow>
            {isEdit && (
              <IconButton marginLeft='12px' onClick={openEdit}>
                <EditIcon />
              </IconButton>
            )}
          </Box>
        </UserDetailsRow>
        <UserDetailsRow>
          <UserDetailsRowTitle>Middle Name</UserDetailsRowTitle>
          <UserDetailsRowValue>{middle_name || '-'}</UserDetailsRowValue>
        </UserDetailsRow>
        <UserDetailsRow>
          <UserDetailsRowTitle>Last Name</UserDetailsRowTitle>
          <UserDetailsRowValue>{last_name || '-'}</UserDetailsRowValue>
        </UserDetailsRow>
      </UserDetailsCard>
    </Box>
  );
};
